import type { IconDef } from '../types';

export const smartphone: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M15 0H8C5.79 0 4 1.79 4 4V20C4 22.21 5.79 24 8 24H15C17.21 24 19 22.21 19 20V4C19 1.79 17.21 0 15 0ZM16.67 20.22C16.63 21.32 15.69 22.18 14.59 22.14L7.6 21.86C6.5 21.82 5.64 20.88 5.68 19.78L6.33 3.78C6.37 2.68 7.31 1.82 8.41 1.86L8.95 1.88V2.51C8.95 3.28 9.58 3.91 10.35 3.91H12.65C13.42 3.91 14.05 3.28 14.05 2.51V2.09L15.4 2.14C16.5 2.18 17.36 3.12 17.32 4.22L16.67 20.21V20.22Z',
    },
  ],
};
